import React, { useState } from "react";
import dayjs from "dayjs";
import LineBtn from "../../../Button/LineBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import VersionUpdateModal from "./ManagerVersion/VersionUpdateModal";

interface IVersion {
  app: number;
  admin: string;
  adminId: number;
  lastUpdate: string;
  latest_ver: string;
  maintenance: number;
}

interface ManageVersionProps {
  versionData?: IVersion[];
  refetch: () => void;
}

export default function ManageVersion({
  versionData,
  refetch,
}: ManageVersionProps) {
  const [updateModal, setUpdateModal] = useState(false);
  const [isApp, setIsApp] = useState(false);

  const tableHead = [
    "구분",
    "버전",
    "최근 업데이트 일시",
    "담당자",
    "업데이트",
  ];

  return (
    <>
      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {versionData?.map((d: IVersion, i: number) => (
              <TableBody key={i}>
                <TableBodyItem>{d?.app ? "앱" : "웹"}</TableBodyItem>
                <TableBodyItem>{d?.latest_ver}</TableBodyItem>
                <TableBodyItem>
                  {dayjs(d?.lastUpdate ?? undefined).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )}
                </TableBodyItem>
                <TableBodyItem>{d?.admin}</TableBodyItem>
                <TableBodyItem>
                  <LineBtn
                    btnText="업데이트"
                    btnClickEvent={() => {
                      setIsApp(d?.app ? true : false);
                      setUpdateModal(true);
                    }}
                  />
                </TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>
      </LineBox>

      {updateModal && (
        <VersionUpdateModal
          closeEvent={() => setUpdateModal(false)}
          confirmEvent={() => refetch()}
          isApp={isApp}
        />
      )}
    </>
  );
}
